import type { WorkspaceResumen } from '@/store/workspace.store';

/**
 * ¿Este negocio se ve en «Mi Conversia» en vez del panel normal?
 *
 * Reflejo, VIP y pendiente corren (o correrán) en su propio sistema: el panel
 * normal saldría vacío. Sin tipo (lista vieja en caché) se trata como nuevo,
 * que es lo que eran todos antes de que existieran los tipos.
 *
 * El panel (AdminShell) y «Mi Conversia» deciden con ESTA función y el mismo
 * dato del store: si decidieran con fuentes distintas podrían mandarse uno al
 * otro para siempre.
 */
export function vaAMiConversia(ws: WorkspaceResumen | null | undefined): boolean {
  return Boolean(ws?.tipoCliente && ws.tipoCliente !== 'nuevo');
}

/**
 * ¿Esta cuenta va a «Mi alta» (contar su negocio y esperar la aprobación)?
 * Solo cuando YA se cargó la lista de negocios, llegó vacía y se sabe que no es
 * el OWNER. Sin lista o sin rol todavía no se decide nada: mejor un instante en
 * blanco que mandar a alguien con negocio a una pantalla que no es suya.
 */
export function vaAMiAlta(input: { role: string | undefined; cargado: boolean; negocios: number }): boolean {
  return Boolean(input.role) && input.role !== 'OWNER' && input.cargado && input.negocios === 0;
}

/** El negocio propio del OWNER: nuevo y con el módulo de operación. */
export function negocioPropio(items: WorkspaceResumen[]): WorkspaceResumen | null {
  return items.find((w) => w.tipoCliente === 'nuevo' && w.conOperacion) ?? null;
}

export type VistaPrograma = 'marco' | 'pestana' | 'preparacion';

/** Qué se pinta debajo de la barra, según lo que diga GET /api/mi-conversia. */
export function vistaDelPrograma(d: { tipo: string; programaUrl: string | null; embebible: boolean }): VistaPrograma {
  // Un pendiente todavía no está en internet aunque ya tenga una URL apuntada.
  if (d.tipo === 'pendiente' || !d.programaUrl) return 'preparacion';
  return d.embebible ? 'marco' : 'pestana';
}
